import React, { Component } from "react";
import * as d3 from "d3";
import { connect } from "react-redux";
import styled from "styled-components";

const GraphContainer = styled.div`
  width: 100%;
  margin-top: 20px;
  text-align: center;
  @media (min-width: 1800px) {
    width: 100%;
  }
`;

class EntitySectorGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        departments: [
          { id: "d1", value: 6, icon: "\uf557", relations: ["s9"] },
          { id: "d2", value: 58, icon: "\uf187", relations: ["s1", "s15"] },
          { id: "d3", value: 89, icon: "\uf0ab", relations: ["s3", "s8"] },
          { id: "d4", value: 87, icon: "\uf1ad", relations: ["s1", "s7"] },
          { id: "d5", value: 10, icon: "\uf518", relations: ["s8", "s15"] },
          { id: "d6", value: 52, icon: "\uf0e7", relations: ["s9", "s5"] },
          { id: "d7", value: 61, icon: "\uf469", relations: ["s5", "s12"] },
          {
            id: "d8",
            value: 5,
            icon: "\uf0a1",
            relations: ["s7", "s10", "s3", "s13"]
          },
          { id: "d9", value: 82, icon: "\uf1ec", relations: ["s1", "s9"] },
          { id: "d10", value: 28, icon: "\uf271", relations: ["s1", "s9"] },
          { id: "d11", value: 29, icon: "\uf786", relations: ["s1", "s9"] },
          { id: "d12", value: 45, icon: "\uf5e1", relations: ["s1", "s9"] },
          { id: "d13", value: 72, icon: "\uf152", relations: ["s1", "s9"] },
          { id: "d14", value: 72, icon: "\uf519", relations: ["s1", "s9"] },
          { id: "d15", value: 61, icon: "\uf51a", relations: ["s1", "s9"] },
          { id: "d16", value: 5, icon: "\uf207", relations: ["s1"] },
          { id: "d17", value: 92, icon: "\uf441", relations: ["s9"] },
          { id: "d18", value: 28, icon: "\uf521", relations: ["s1", "s9"] },
          { id: "d19", value: 79, icon: "\uf06d", relations: ["s1", "s9"] },
          { id: "d20", value: 28, icon: "\uf271", relations: ["s1", "s9"] },
          { id: "d21", value: 29, icon: "\uf786", relations: ["s1", "s9"] },
          { id: "d22", value: 45, icon: "\uf5e1", relations: ["s1", "s9"] },
          { id: "d23", value: 72, icon: "\uf152", relations: ["s1", "s9"] },
          { id: "d24", value: 72, icon: "\uf519", relations: ["s1", "s9"] },
          { id: "d25", value: 61, icon: "\uf51a", relations: ["s1", "s9"] },
          { id: "d26", value: 5, icon: "\uf207", relations: ["s1", "s9"] },
          { id: "d27", value: 92, icon: "\uf441", relations: ["s1", "s9"] },
          { id: "d28", value: 28, icon: "\uf521", relations: ["s1", "s9"] },
          { id: "d29", value: 45, icon: "\uf5e1", relations: ["s1", "s9"] },
          { id: "d30", value: 79, icon: "\uf06d", relations: ["s1", "s9"] }
        ],
        sections: [
          { id: "s1", value: 95, icon: "\uf004", relations: ["d11", "d23"] },
          { id: "s2", value: 72, icon: "\uf519", relations: ["d11", "d23"] },
          { id: "s3", value: 100, icon: "\uf51a", relations: ["d11", "d23"] },
          { id: "s4", value: 50, icon: "\uf207", relations: ["d11", "d23"] },
          {
            id: "s5",
            value: 22,
            icon: "\uf441",
            relations: ["d11", "d23", "d2", "d28"]
          },
          { id: "s6", value: 78, icon: "\uf521", relations: ["d11", "d23"] },
          { id: "s7", value: 49, icon: "\uf06d", relations: ["d11", "d23"] },
          { id: "s8", value: 77, icon: "\uf254", relations: ["d11", "d23"] },
          { id: "s9", value: 35, icon: "\uf0f8", relations: ["d11", "d23"] },
          { id: "s10", value: 92, icon: "\uf6ec", relations: ["d11", "d23"] },
          { id: "s11", value: 77, icon: "\uf4c2", relations: ["d11", "d23"] },
          { id: "s12", value: 39, icon: "\uf66f", relations: ["d11", "d23"] },
          { id: "s13", value: 92, icon: "\uf6ec", relations: ["d11", "d23"] },
          { id: "s14", value: 77, icon: "\uf4c2", relations: ["d11", "d23"] },
          { id: "s15", value: 39, icon: "\uf66f", relations: ["d11", "d23"] }
        ]
      }
    };
  }
  componentDidMount() {
    this.drawChart();
  }

  componentDidUpdate(prevProps) {
    if (this.props.theme !== prevProps.theme) {
      this.drawChart();
    }
  }

  getDimension = container => {
    let containerWidth = container.node().getBoundingClientRect().width,
      viewportWidth = window.innerWidth,
      viewportHeight = window.innerHeight;

    let orientation;

    if (viewportHeight > viewportWidth) orientation = "potrait";
    else orientation = "landscape";

    if (orientation === "potrait") return containerWidth;
    else return (70 * viewportHeight) / 100;
  };

  drawChart = () => {
    const { showMoreAction, setChosenDetail, theme } = this.props;
    var { departments, sections } = this.state.data;
    var data = Array(departments.concat(sections));
    var container = d3.select(this.graph);

    var margin = { top: 30, right: 30, bottom: 30, left: 30 },
      width = this.getDimension(container) - margin.left - margin.right,
      height = width,
      entityCircleRadius = "1.6vh",
      chosenCircleRadius = 23,
      plotPointRadius = 4,
      basePointRadius = 2,
      textFontSize = 12,
      entityIconSize = "1.6vh",
      chosenEntityIconSize = 23,
      showMoreButton = { height: 30, width: 150, borderRadius: 15 };

    if (window.innerWidth > 1800) {
      margin = { top: 50, right: 50, bottom: 50, left: 50 };
      entityCircleRadius = 17.5;
      chosenCircleRadius = 35;
      plotPointRadius = 5;
      basePointRadius = 2.5;
      textFontSize = 17.5;
      chosenEntityIconSize = 30;
      showMoreButton = { height: 50, width: 200, borderRadius: 30 };
    } else if (window.innerWidth < 575) {
      margin = { top: 18, right: 18, bottom: 18, left: 18 };
      entityCircleRadius = 9;
      chosenCircleRadius = 13;
      entityIconSize = 10;
      plotPointRadius = 2.5;
      basePointRadius = 1.5;
      textFontSize = 10;
      chosenEntityIconSize = 13;
      showMoreButton = { height: 25, width: 100, borderRadius: 15 };
    }

    var gradients = {
      light: [["#E8DBDB", "#6678D1"], ["#E8DBDB", "#E26A71"]],
      dark: [["#041A2F", "#6678D1"], ["#041A2F", "#E26A71"]]
    };

    var cfg = {
      w: width, //Width of the circle
      h: height, //Height of the circle
      margin, //The margins of the SVG
      levels: 3, //How many levels or inner circles should there be drawn
      maxValue: 100, //What is the value that the biggest circle will represent
      labelFactor: 1.15, //How much farther than the radius of the outer circle should the labels be placed
      color: d3.scaleOrdinal().range(["#6678D1", "#E26A71"]),
      graphGradient: gradients[this.props.theme],
      offset: 100, //offset from which axis starts
      entityCircleRadius,
      plotPointRadius,
      basePointRadius,
      textFontSize,
      entityIconSize,
      chosenCircleRadius,
      chosenEntityIconSize,
      showMoreButton
    };

    //If the supplied maxValue is smaller than the actual one, replace by the max in the data
    var maxValue = Math.max(
      cfg.maxValue,
      d3.max(data, function (i) {
        return d3.max(
          i.map(function (o) {
            return o.value;
          })
        );
      })
    );

    //adding the offset to the maxvalue
    maxValue += cfg.offset;

    var allAxis = data[0].map(function (i, j) {
      return i.axis;
    }), //Names of each axis
      total = allAxis.length + 2, //The number of different axes (adding 2 extra for space between axes of departments and sections)
      radius = (cfg.w - cfg.margin.left * 2) / 2, //Radius of the outermost circle
      angleSlice = (Math.PI * 2) / total, //The width in radians of each "slice"
      deptCountHalf = Math.round(-(departments.length / 2)); //To identify from which angle graph should start

    //Scale for the radius
    var rScale = d3
      .scaleLinear()
      .range([0, radius])
      .domain([0, maxValue]);

    var paddedRScale = d3
      .scaleLinear()
      .range([0, radius - cfg.plotPointRadius - cfg.basePointRadius])
      .domain([0, maxValue]);

    // calculating difference in radius between different levels
    var levelRadius = (radius - rScale(cfg.offset)) / cfg.levels;

    /////////////////////////////////////////////////////////
    //////////// Create the container SVG and g /////////////
    /////////////////////////////////////////////////////////

    //Remove whatever chart with the same id/class was present before
    container.select("svg").remove();

    //Initiate the radar chart SVG
    var svg = container
      .append("svg")
      .attr("width", cfg.w + cfg.margin.left + cfg.margin.right)
      .attr("height", cfg.h + cfg.margin.top + cfg.margin.bottom);

    //Append a g element
    var g = svg
      .append("g")
      .attr(
        "transform",
        "translate(" +
        (cfg.w / 2 + cfg.margin.left) +
        "," +
        (cfg.h / 2 + cfg.margin.top) +
        ")"
      );

    ///////////////////////////////////////////////////
    ///////////// Create the radial gradient //////////
    ///////////////////////////////////////////////////

    // Gradient for department
    var numColors = 10;
    var colorScaleDept = d3
      .scaleLinear()
      .domain([0, (numColors - 1) / 2, numColors - 1])
      .range(cfg.graphGradient[0]);

    svg
      .append("defs")
      .append("radialGradient")
      .attr("id", "radial-gradient-dept")
      .attr("gradientUnits", "userSpaceOnUse")
      .attr("cx", "0%")
      .attr("cy", "0%")
      .attr("r", "40%")
      .selectAll("stop")
      .data(d3.range(numColors))
      .enter()
      .append("stop")
      .attr("offset", function (d, i) {
        return (i / (numColors - 1)) * 50 + 40 + "%";
      })
      .attr("stop-color", function (d) {
        return colorScaleDept(d);
      });

    // Gradient for section
    var colorScaleDept = d3
      .scaleLinear()
      .domain([0, (numColors - 1) / 2, numColors - 1])
      .range(cfg.graphGradient[1]);

    svg
      .append("defs")
      .append("radialGradient")
      .attr("id", "radial-gradient-section")
      .attr("gradientUnits", "userSpaceOnUse")
      .attr("cx", "0%")
      .attr("cy", "0%")
      .attr("r", "40%")
      .selectAll("stop")
      .data(d3.range(numColors))
      .enter()
      .append("stop")
      .attr("offset", function (d, i) {
        return (i / (numColors - 1)) * 50 + 40 + "%";
      })
      .attr("stop-color", function (d) {
        return colorScaleDept(d);
      });

    ///////////////////////////////////////////////////
    ///////// Inter-relation linear gradient //////////
    ///////////////////////////////////////////////////

    var linearGradient = svg
      .append("defs")
      .append("linearGradient")
      .attr("id", "dept-section-gradient")
      .attr("gradientTransform", "rotate(90)");

    linearGradient
      .append("stop")
      .attr("offset", "0%")
      .attr("stop-color", cfg.color(0));

    linearGradient
      .append("stop")
      .attr("offset", "100%")
      .attr("stop-color", cfg.color(1));

    /////////////////////////////////////////////////////////
    /////////////// Draw the Circular grid //////////////////
    /////////////////////////////////////////////////////////

    //Wrapper for the grid & axes
    var axisGrid = g.append("g").attr("class", "axisWrapper");

    //Draw the background circles for indicating performance level
    axisGrid
      .selectAll(".levels")
      .data(d3.range(1, cfg.levels + 1).reverse())
      .enter()
      .append("circle")
      .attr("class", "levels")
      .attr("r", function (d, i) {
        return radius - levelRadius * i;
      })
      .style("fill", "none")
      .style("stroke", "#1b567a")
      .style("stroke-width", "0.5pt")
      .style("stroke-dasharray", "1.5,2")
      .style("opacity", 0)
      .transition()
      .duration(500)
      .delay(1000 + 20 * departments.length)
      .style("opacity", 1);

    /////////////////////////////////////////////////////////
    //////////////////// Draw the axes //////////////////////
    /////////////////////////////////////////////////////////

    //Create the straight lines radiating outward from the center

    var axis = axisGrid
      .selectAll(".axis")
      .data(departments)
      .enter()
      .append("g")
      .attr("class", "axis");

    var axis2 = axisGrid
      .selectAll(".axis2")
      .data(sections)
      .enter()
      .append("g")
      .attr("class", "axis2");

    //Append the axis lines
    axis
      .append("line")
      .attr("x1", function (d, i) {
        let j = i + deptCountHalf;
        return rScale(cfg.offset) * Math.cos(angleSlice * j - Math.PI / 2);
      })
      .attr("y1", function (d, i) {
        let j = i + deptCountHalf;
        return rScale(cfg.offset) * Math.sin(angleSlice * j - Math.PI / 2);
      })
      .attr("x2", function (d, i) {
        let j = i + deptCountHalf;
        return rScale(maxValue * 1.1) * Math.cos(angleSlice * j - Math.PI / 2);
      })
      .attr("y2", function (d, i) {
        let j = i + deptCountHalf;
        return rScale(maxValue * 1.1) * Math.sin(angleSlice * j - Math.PI / 2);
      })
      .attr("class", "axes")
      .style("stroke-dasharray", "1.5,2")
      .style("stroke", "#1b567a")
      .style("stroke-width", "0.5pt")
      .style("opacity", 0)
      .transition()
      .delay(300)
      .style("opacity", 1);

    axis2
      .append("line")
      .attr("x1", function (d, i) {
        let j = -(i + 2) + deptCountHalf;
        return rScale(cfg.offset) * Math.cos(angleSlice * j - Math.PI / 2);
      })
      .attr("y1", function (d, i) {
        let j = -(i + 2) + deptCountHalf;
        return rScale(cfg.offset) * Math.sin(angleSlice * j - Math.PI / 2);
      })
      .attr("x2", function (d, i) {
        let j = -(i + 2) + deptCountHalf;
        return rScale(maxValue * 1.1) * Math.cos(angleSlice * j - Math.PI / 2);
      })
      .attr("y2", function (d, i) {
        let j = -(i + 2) + deptCountHalf;
        return rScale(maxValue * 1.1) * Math.sin(angleSlice * j - Math.PI / 2);
      })
      .attr("class", "axes")
      .style("stroke-dasharray", "1.5,2")
      .style("stroke", "#1b567a")
      .style("stroke-width", "0.5pt")
      .style("opacity", 0)
      .transition()
      .delay(1200 + departments.length * 20)
      .style("opacity", 1);

    /////////////////////////////////////////////////////////
    //////// Append the department/section buttons //////////
    /////////////////////////////////////////////////////////

    var deptButtonGroups = axis
      .append("g")
      .attr("class", function (d, i) {
        return `buttons buttonGroup-${i}`;
      })
      .style("cursor", "pointer")
      .attr("id", function (d, i) {
        return i;
      });

    deptButtonGroups
      .append("circle")
      .attr("class", function (d, i) {
        return `buttonCircles button-${i}`;
      })
      .attr("cx", function (d, i) {
        let j = departments.length - 1 - i + deptCountHalf;
        return (
          rScale(maxValue * cfg.labelFactor) *
          Math.cos(angleSlice * j - Math.PI / 2)
        );
      })
      .attr("cy", function (d, i) {
        let j = departments.length - 1 - i + deptCountHalf;
        return (
          rScale(maxValue * cfg.labelFactor) *
          Math.sin(angleSlice * j - Math.PI / 2)
        );
      })
      .attr("fill", cfg.color(0))
      .attr("r", 0)
      .transition()
      .duration(500)
      .delay(function (d, i) {
        return 800 + 20 * i;
      })
      .attr("r", cfg.entityCircleRadius);

    //department icons
    deptButtonGroups
      .append("text")
      .attr("text-anchor", "middle")
      .attr("dominant-baseline", "central")
      .attr("fill", "white")
      .attr("class", function (d, i) {
        return `fa buttonIcon icon-${i}`;
      })
      .attr("x", function (d, i) {
        let j = departments.length - 1 - i + deptCountHalf;
        return (
          rScale(maxValue * cfg.labelFactor) *
          Math.cos(angleSlice * j - Math.PI / 2)
        );
      })
      .attr("y", function (d, i) {
        let j = departments.length - 1 - i + deptCountHalf;
        return (
          rScale(maxValue * cfg.labelFactor) *
          Math.sin(angleSlice * j - Math.PI / 2)
        );
      })
      .text(function (d) {
        return d.icon;
      })
      .attr("font-size", 0)
      .transition()
      .duration(500)
      .delay(function (d, i) {
        return 900 + 20 * i;
      })
      .attr("font-size", cfg.entityIconSize);

    //Section button-icon group
    var sectionButtonGroups = axis2
      .append("g")
      .attr("class", "buttons")
      .style("cursor", "pointer")
      .attr("id", function (d, i) {
        return departments.length + i;
      });

    //Section button
    sectionButtonGroups
      .append("circle")
      .attr("class", function (d, i) {
        return `buttonCircles button-${departments.length + i}`;
      })
      .attr("cx", function (d, i) {
        let j = -(i + 2) + deptCountHalf;
        return (
          rScale(maxValue * cfg.labelFactor) *
          Math.cos(angleSlice * j - Math.PI / 2)
        );
      })
      .attr("cy", function (d, i) {
        let j = -(i + 2) + deptCountHalf;
        return (
          rScale(maxValue * cfg.labelFactor) *
          Math.sin(angleSlice * j - Math.PI / 2)
        );
      })
      .attr("fill", cfg.color(1))
      .attr("r", 0)
      .transition()
      .duration(500)
      .delay(function (d, i) {
        return 2200 + 20 * i + departments.length + sections.length;
      })
      .attr("r", cfg.entityCircleRadius);

    //Section icon
    sectionButtonGroups
      .append("text")
      .attr("text-anchor", "middle")
      .attr("dominant-baseline", "central")
      .attr("fill", "white")
      .attr("class", function (d, i) {
        return `fa buttonIcon icon-${departments.length + i}`;
      })
      .attr("x", function (d, i) {
        let j = -(i + 2) + deptCountHalf;
        return (
          rScale(maxValue * cfg.labelFactor) *
          Math.cos(angleSlice * j - Math.PI / 2)
        );
      })
      .attr("y", function (d, i) {
        let j = -(i + 2) + deptCountHalf;
        return (
          rScale(maxValue * cfg.labelFactor) *
          Math.sin(angleSlice * j - Math.PI / 2)
        );
      })
      .text(function (d) {
        return d.icon;
      })
      .attr("font-size", 0)
      .transition()
      .duration(500)
      .delay(function (d, i) {
        return 2200 + 20 * i + departments.length + sections.length;
      })
      .attr("font-size", cfg.entityIconSize);

    /////////////////////////////////////////////////////////
    ///////////// Draw the radar chart blobs ////////////////
    /////////////////////////////////////////////////////////

    //Draw the plotted area
    var deptArea = d3
      .areaRadial()
      .curve(d3.curveCardinal.tension(0.3))
      .angle(function (d, i) {
        let j = departments.length - 1 - i + deptCountHalf;

        return j * angleSlice;
      })
      .outerRadius(rScale(cfg.offset))
      .innerRadius(function (d, i) {
        return rScale(d.value + cfg.offset);
      });

    var sectionArea = d3
      .areaRadial()
      .curve(d3.curveCardinal.tension(0.3))
      .angle(function (d, i) {
        let j = -(i + 2) + deptCountHalf;
        return j * angleSlice;
      })
      .outerRadius(rScale(cfg.offset))
      .innerRadius(function (d, i) {
        return rScale(d.value + cfg.offset);
      });

    //Create a wrapper for the blobs
    var blobWrapper = g
      .selectAll(".radarWrapper")
      .data(Array(departments))
      .enter()
      .append("g")
      .attr("class", "radarWrapper");

    var blobWrapper2 = g
      .selectAll(".radarWrapper2")
      .data(Array(sections))
      .enter()
      .append("g")
      .attr("class", "radarWrapper2");

    //Append the backgrounds
    blobWrapper
      .append("path")
      .attr("class", "radarArea")
      .attr("d", function (d, i) {
        return deptArea(d);
      })
      .style("fill", "url(#radial-gradient-dept)")
      .style("fill-opacity", 0)
      .transition()
      .duration(2500)
      .delay(function (d, i) {
        return 1000 + 20 * i;
      })
      .style("fill-opacity", 0.8);

    blobWrapper2
      .append("path")
      .attr("class", "radarArea")
      .attr("d", function (d, i) {
        return sectionArea(d);
      })
      .style("fill", "url(#radial-gradient-section)")
      .style("fill-opacity", 0)
      .transition()
      .duration(2500)
      .delay(function (d, i) {
        return 1000 + 20 * i + departments.length;
      })
      .style("fill-opacity", 0.8);

    //draw base circle
    var deptBase = d3
      .radialLine()
      .radius(function (d, i) {
        return rScale(cfg.offset);
      })
      .angle(function (d, i) {
        let j = i + deptCountHalf;
        return j * angleSlice;
      });

    var sectionBase = d3
      .radialLine()
      .radius(function (d, i) {
        return rScale(cfg.offset);
      })
      .angle(function (d, i) {
        let j = -(i + 2) + deptCountHalf;
        return j * angleSlice;
      });

    //base outline
    blobWrapper
      .append("path")
      .attr("class", "radarStroke")
      .attr("d", function (d, i) {
        return deptBase(d);
      })
      .style("stroke-width", 1)
      .style("stroke", cfg.graphGradient[0][1])
      .style("fill", "none")
      .style("opacity", 0)
      .transition()
      .delay(400)
      .style("opacity", 1);

    blobWrapper2
      .append("path")
      .attr("class", "radarStroke")
      .attr("d", function (d, i) {
        return sectionBase(d);
      })
      .style("stroke-width", 1)
      .style("stroke", cfg.color(1))
      .style("fill", "none")
      .style("opacity", 0)
      .transition()
      .delay(1200 + 20 * departments.length)
      .style("opacity", 1);

    //Plot exact position with circle
    blobWrapper
      .selectAll(".plots")
      .data(function (d, i) {
        return d;
      })
      .enter()
      .append("circle")
      .attr("class", function (d, i) {
        return `plots plot-${i}`;
      })
      .attr("cx", function (d, i) {
        let j = departments.length - 1 - i + deptCountHalf;
        return (
          rScale(d.value + cfg.offset) * Math.cos(angleSlice * j - Math.PI / 2)
        );
      })
      .attr("cy", function (d, i) {
        let j = departments.length - 1 - i + deptCountHalf;
        return (
          rScale(d.value + cfg.offset) * Math.sin(angleSlice * j - Math.PI / 2)
        );
      })
      .style("fill", "#fff")
      .attr("r", 0)
      .transition()
      .duration(500)
      .delay(function (d, i) {
        return 1000 + 20 * i;
      })
      .attr("r", cfg.plotPointRadius);

    blobWrapper2
      .selectAll(".plots")
      .data(function (d, i) {
        return d;
      })
      .enter()
      .append("circle")
      .attr("class", function (d, i) {
        return `plots plot-${departments.length + i}`;
      })
      .attr("r", cfg.plotPointRadius)
      .attr("cx", function (d, i) {
        let j = -(i + 2) + deptCountHalf;
        return (
          rScale(d.value + cfg.offset) * Math.cos(angleSlice * j - Math.PI / 2)
        );
      })
      .attr("cy", function (d, i) {
        let j = -(i + 2) + deptCountHalf;
        return (
          rScale(d.value + cfg.offset) * Math.sin(angleSlice * j - Math.PI / 2)
        );
      })
      .style("fill", "#fff")
      .attr("r", 0)
      .transition()
      .duration(500)
      .delay(function (d, i) {
        return 1200 + departments.length * 20 + 20 * i;
      })
      .attr("r", cfg.plotPointRadius);

    // Transactions Text
    blobWrapper
      .append("text")
      .attr("class", "transactionsText")
      .attr("x", 0)
      .attr("y", 0)
      .attr("text-anchor", "middle")
      .attr("dominant-baseline", "central")
      .attr("direction", "rtl")
      .style("fill", function () {
        if (theme === "dark") return "#fff";
        else return "#413446";
      })
      .style("font-size", cfg.textFontSize)
      .transition()
      .delay(2800 * data.length)
      .text("340,000 معاملة ");

    // Show more redirection button
    var showMoreButton = blobWrapper
      .append("g")
      .attr("class", "showMoreButton")
      .style("cursor", "pointer")
      .style("opacity", 0);

    showMoreButton
      .append("rect")
      .attr("class", "showMoreButtonRect")
      .attr("rx", cfg.showMoreButton.borderRadius)
      .attr("ry", cfg.showMoreButton.borderRadius)
      .attr("x", -(cfg.showMoreButton.width / 2))
      .attr("y", -(cfg.showMoreButton.height / 2))
      .attr("height", cfg.showMoreButton.height)
      .attr("width", cfg.showMoreButton.width)
      .style("fill", cfg.color(1));

    showMoreButton
      .append("text")
      .attr("class", "showMoreButtonText")
      .attr("x", 0)
      .attr("y", 0)
      .text("More about the department")
      .attr("text-anchor", "middle")
      .attr("dominant-baseline", "central")
      .style("fill", "#fff")
      .style("font-size", cfg.textFontSize);

    /////////////////////////////////////////////////////////
    //// Text showing the number of departments/Sections ////
    /////////////////////////////////////////////////////////

    blobWrapper
      .append("text")
      .style("text-anchor", "middle")
      .style("font-size", cfg.textFontSize)
      .attr("startOffset", "50%")
      .attr("direction", "rtl")
      .attr("x", 0)
      .attr("y", rScale(-cfg.offset + 40))
      .style("fill", cfg.color(0))
      .transition()
      .delay(800 + 20 * departments.length)
      .attr("class", "countText")
      .text(` ${departments.length} جـــــهة حـــــــكومـــــيـــــــة`);

    blobWrapper2
      .append("text")
      .style("text-anchor", "middle")
      .style("font-size", cfg.textFontSize)
      .attr("direction", "rtl")
      .attr("x", 0)
      .attr("y", rScale(cfg.offset - 40))
      .attr("startOffset", "50%")
      .style("fill", cfg.color(1))
      .transition()
      .delay(1200 + 20 * departments.length)
      .attr("class", "countText")
      .text(`${sections.length} قــــطـــــاع إســـتـــراتـــيـــجـــي`);

    /////////////////////////////////////////////////////////
    ////// Relation Lines b/w Sections and Departments //////
    /////////////////////////////////////////////////////////

    var lineGenerator = d3.line().curve(d3.curveBasis);

    //Department to section relation
    axis.each(function (d, i) {
      let j = departments.length - 1 - i + deptCountHalf;
      d3.select(this)
        .selectAll(".relation-lines")
        .data(d.relations)
        .enter()
        .append("path")
        .attr("d", function (e) {
          let points = [
            [
              rScale(cfg.offset + d.value) *
              Math.cos(angleSlice * j - Math.PI / 2),
              rScale(cfg.offset + d.value) *
              Math.sin(angleSlice * j - Math.PI / 2)
            ],
            [0, 0]
          ];

          sections.map((section, i) => {
            if (e === section.id) {
              let j = -(i + 2) + deptCountHalf;
              points.push([
                rScale(section.value + cfg.offset) *
                Math.cos(angleSlice * j - Math.PI / 2),
                rScale(section.value + cfg.offset) *
                Math.sin(angleSlice * j - Math.PI / 2)
              ]);
            }
          });
          return lineGenerator(points);
        })
        .attr("class", `relation-lines relation-line-${i}`)
        .style("stroke", "url(#dept-section-gradient)")
        .style("fill", "none")
        .style("stroke-width", 3)
        .style("opacity", 0);
    });

    //Section to Department relation
    axis2.each(function (d, i) {
      let j = -(i + 2) + deptCountHalf;
      d3.select(this)
        .selectAll(".relation-lines")
        .data(d.relations)
        .enter()
        .append("path")
        .attr("d", function (e) {
          let points = [
            [
              rScale(cfg.offset + d.value) *
              Math.cos(angleSlice * j - Math.PI / 2),
              rScale(cfg.offset + d.value) *
              Math.sin(angleSlice * j - Math.PI / 2)
            ],
            [0, 0]
          ];

          departments.map((section, i) => {
            if (e === section.id) {
              let j = departments.length - 1 - i + deptCountHalf;
              points.push([
                rScale(section.value + cfg.offset) *
                Math.cos(angleSlice * j - Math.PI / 2),
                rScale(section.value + cfg.offset) *
                Math.sin(angleSlice * j - Math.PI / 2)
              ]);
            }
          });
          return lineGenerator(points);
        })
        .attr("class", `relation-lines relation-line-${departments.length + i}`)
        .style("stroke", "url(#dept-section-gradient)")
        .style("fill", "none")
        .style("stroke-width", 3)
        .style("opacity", 0);
    });

    //Append circle at the starting of the axes
    blobWrapper
      .selectAll(".baseCircles")
      .data(function (d, i) {
        return d;
      })
      .enter()
      .append("circle")
      .attr("class", function (d, i) {
        return `baseCircles baseCircle-${i}`;
      })
      .attr("cx", function (d, i) {
        let j = departments.length - 1 - i + deptCountHalf;
        return rScale(cfg.offset) * Math.cos(angleSlice * j - Math.PI / 2);
      })
      .attr("cy", function (d, i) {
        let j = departments.length - 1 - i + deptCountHalf;
        return rScale(cfg.offset) * Math.sin(angleSlice * j - Math.PI / 2);
      })
      .attr("fill", cfg.color(0))
      .attr("r", 0)
      .transition()
      .delay(400)
      .attr("r", cfg.basePointRadius);

    blobWrapper2
      .selectAll(".baseCircles")
      .data(function (d, i) {
        return d;
      })
      .enter()
      .append("circle")
      .attr("class", function (d, i) {
        return `baseCircles baseCircle-${departments.length + i}`;
      })
      .attr("cx", function (d, i) {
        let j = -(i + 2) + deptCountHalf;
        return rScale(cfg.offset) * Math.cos(angleSlice * j - Math.PI / 2);
      })
      .attr("cy", function (d, i) {
        let j = -(i + 2) + deptCountHalf;
        return rScale(cfg.offset) * Math.sin(angleSlice * j - Math.PI / 2);
      })
      .attr("fill", cfg.color(1))
      .attr("r", 0)
      .transition()
      .delay(1200 + 20 * departments.length)
      .attr("r", cfg.basePointRadius);

    /////////////////////////////////////////////////////////
    ////////////////// Click actions ////////////////////////
    /////////////////////////////////////////////////////////

    d3.select("body").on("click", function () {
      var buttons = d3.selectAll(".buttons");

      let isInside = false,
        isShowMore = false;

      if (d3.event.target.parentNode === d3.select(".showMoreButton").node()) {
        isShowMore = true;
      }

      buttons.nodes().map(item => {
        if (d3.event.target.parentNode === item) {
          isInside = true;
        }
      });
      if (isInside) {
        buttons
          .selectAll(".buttonCircles")
          .attr("r", cfg.entityCircleRadius)
          .style("opacity", 0.2);

        d3.selectAll(".buttonIcon")
          .style("opacity", 0.2)
          .style("font-size", cfg.entityIconSize);

        d3.selectAll(".axes").style("stroke-opacity", 0.1);
        d3.selectAll(".levels").style("stroke-opacity", 0.1);
        d3.selectAll(".plots").style("fill-opacity", 0.5);
        d3.selectAll(".radarArea").style("opacity", 0.2);
        d3.selectAll(".radarStroke").style("opacity", 0.1);
        d3.selectAll(".baseCircles").style("opacity", 0.1);
        d3.selectAll(".countText").style("opacity", 0.1);

        d3.selectAll(".relation-lines").style("opacity", 0);

        var showMoreButton = d3.select(".showMoreButton").style("opacity", 1);

        if (departments.length > d3.event.target.parentNode.id) {
          //Actions only for department click

          setChosenDetail("ENTITY");

          showMoreButton
            .select(".showMoreButtonRect")
            .style("fill", cfg.color(0));
          showMoreButton.select(".showMoreButtonText").text("المزيد عن الجهة");
          if (
            departments[d3.event.target.parentNode.id].relations.length !== 0
          ) {
            let relatedSections =
              departments[d3.event.target.parentNode.id].relations;
            relatedSections.map(relatedSection => {
              sections.map((section, i) => {
                if (relatedSection === section.id) {
                  d3.select(`.button-${departments.length + i}`)
                    .style("opacity", 1)
                    .attr("r", cfg.chosenCircleRadius);

                  d3.select(`.plot-${departments.length + i}`).style(
                    "fill-opacity",
                    1
                  );
                  d3.select(`.icon-${departments.length + i}`)
                    .style("opacity", 1)
                    .style("font-size", cfg.chosenEntityIconSize);
                }
              });
            });
          }
        } else {
          //Actions only for section click

          setChosenDetail("SECTOR");

          showMoreButton
            .select(".showMoreButtonRect")
            .style("fill", cfg.color(1));
          showMoreButton.select(".showMoreButtonText").text("المزيد عن القطاع");

          if (
            sections[d3.event.target.parentNode.id - departments.length]
              .relations.length !== 0
          ) {
            let relatedDepartments =
              sections[d3.event.target.parentNode.id - departments.length]
                .relations;
            relatedDepartments.map(relatedDept => {
              departments.map((department, i) => {
                if (relatedDept === department.id) {
                  d3.select(`.button-${i}`)
                    .style("opacity", 1)
                    .attr("r", cfg.chosenCircleRadius);
                  d3.select(`.plot-${i}`).style("fill-opacity", 1);
                  d3.select(`.icon-${i}`)
                    .style("opacity", 1)
                    .style("font-size", cfg.chosenEntityIconSize);
                }
              });
            });
          }
        }

        d3.selectAll(`.relation-line-${d3.event.target.parentNode.id}`).style(
          "opacity",
          1
        );
        d3.select(`.plot-${d3.event.target.parentNode.id}`).style(
          "fill-opacity",
          1
        );
        d3.select(`.button-${d3.event.target.parentNode.id}`)
          .style("opacity", 1)
          .attr("r", cfg.chosenCircleRadius);

        d3.select(`.icon-${d3.event.target.parentNode.id}`)
          .style("opacity", 1)
          .style("font-size", cfg.chosenEntityIconSize);
      } else if (isShowMore) {
        // Action on show more click
        d3.select(this.graph)
          .select("svg")
          .remove();
        showMoreAction();
      } else {
        buttons
          .selectAll(".buttonCircles")
          .attr("r", cfg.entityCircleRadius)
          .style("opacity", 1);

        d3.selectAll("svg *")
          .style("opacity", 1)
          .style("stroke-opacity", 1);

        d3.select(".showMoreButton").style("opacity", 0);

        d3.selectAll(".buttonIcon")
          .style("opacity", 1)
          .style("font-size", cfg.entityIconSize);

        d3.selectAll(".plots").style("fill-opacity", 1);
        d3.selectAll(".relation-lines").style("opacity", 0);
      }
    });
  };

  render() {
    return <GraphContainer ref={el => (this.graph = el)} className="graph" />;
  }
}
const mapStateToProps = state => ({
  theme: state.themes.theme
});

export default connect(
  mapStateToProps,
  null
)(EntitySectorGraph);